import { useState, useEffect } from "react";
import { Container, Background, Hr, Titulo, Button, DivInput, Row, Table } from "./style";
import { IoPencilOutline, IoTrashOutline } from "react-icons/io5";
import api from "../../../services/api";
import { Swal, Toast } from "../../../services/SwalTemplates";
import Pagination from "../../../components/Pagination";
import ModalRegister from "../../../components/Modal/Rh/Colaboradores/Register.js";
import ModalEdit from "../../../components/Modal/Rh/Colaboradores/Edit.js";
import { formatCpfInput, stripCpf } from "../../../utils/cpf";

export default function ColaboradoresSec() {
  const [showModalRegister, setShowModalRegister] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [searchMatricula, setSearchMatricula] = useState("");
  const [searchVinculo, setSearchVinculo] = useState("");
  const [searchCpf, setSearchCpf] = useState("");
  const [searchFiltro, setSearchFiltro] = useState("ativo"); // "ativo" ou "todos"
  const [colaborador, setColaborador] = useState("");
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    api
      .get(`/rh/contributors?nome=${search}&vinculo=${searchVinculo}&matricula=${searchMatricula}&cpf=${stripCpf(searchCpf)}`)
      .then((response) => {
        setColaboradores(response.data.colaboradores);
      })
      .catch((error) => {
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os dados!",
          icon: "error",
        });
      });
  }, [search, searchVinculo, searchMatricula, searchCpf]);

  useEffect(() => {
    setTotalPages(Math.ceil(colaboradores.filter((c) => (searchFiltro === "ativo" ? c.inativo === 0 : c)).length / 15));
  }, [colaboradores, searchFiltro]);

 

  return (
    <Background>
      <Container>
        <Titulo>Controle de Colaboradores</Titulo>
        <Hr />
        <Row>
          
          <DivInput style={{ border: "1px solid #000", borderRadius: 3 }}>
            <b>Filtro</b>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  checked={searchFiltro === "ativo"}
                  onClick={() => setSearchFiltro(searchFiltro === "ativo" ? "todos" : "ativo")}
                />
                Ativo
              </label>
              <label>
                <input
                  type="radio"
                  checked={searchFiltro === "todos"}
                  onClick={() => setSearchFiltro(searchFiltro === "todos" ? "ativo" : "todos")}
                />
                Todos
              </label>
            </div>
          </DivInput>
          <DivInput>
            <input
              value={searchMatricula}
              onChange={(e) => {
                setSearchMatricula(e.target.value);
                setPage(1);
              }}
              type="search"
              onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ""))}
              placeholder="Pesquisar matricula..."
            />
          </DivInput>
          <DivInput>
            <input
              value={search}
              onChange={(e) => {
                setSearch(e.target.value.toUpperCase());
                setPage(1);
              }}
              type="search"
              placeholder="Pesquisar colaborador..."
            />
          </DivInput>
          <DivInput>
            <input
              value={searchVinculo}
              onChange={(e) => {
                setSearchVinculo(e.target.value.toUpperCase());
                setPage(1);
              }}
              type="search"
              placeholder="Pesquisar vinculo..."
            />
          </DivInput>
          <DivInput>
            <input
              value={searchCpf}
              onChange={(e) => {
                setSearchCpf(formatCpfInput(e.target.value));
                setPage(1);
              }}
              type="search"
              inputMode="numeric"
              pattern="\d{3}\.\d{3}\.\d{3}-\d{2}"
              maxLength={14}
              placeholder="Pesquisar CPF..."
            />
          </DivInput>
        </Row>
        <Table>
          <table>
            <thead>
              <tr>
                <th>Matrícula</th>
                <th>Nome</th>
                <th>Vínculo</th>
                <th>Apelido</th>
                <th>CPF</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {colaboradores
                .filter((c) => (searchFiltro === "ativo" ? c.inativo === 0 : c))
                .slice((page - 1) * 15, page * 15)
                .map((c, i) => (
                  <tr key={i} style={{ opacity: c.inativo === 1 && 0.2 }}>
                    <td data-title="Matrícula" value={c.matricula}>
                      {c.matricula}
                    </td>
                    <td data-title="Nome" value={c.nome} className="td-left">
                      {c.nome}
                    </td>
                    <td data-title="Vínculo" value={c.vinculo} className="td-left">
                      {c.vinculo}
                    </td>
                    <td data-title="apelido" value={c.apelido} className="td-left">
                      {c.apelido}
                    </td>
                    <td data-title="CPF" value={c.cpf}>
                      {formatCpfInput(c.cpf)}
                    </td>
                    <td data-title="Ativo">{c.inativo === 0 ? "Ativo" : "Inativo"}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Table>
        <Pagination page={page} setPage={setPage} totalPages={totalPages} />
      </Container>
    </Background>
  );
}
